import { Fragment } from 'react';

import clsx from 'clsx';

import { Check } from '../Icons';

import styles from './Steps.module.scss';

type StepsProps = {
  /**
   * An array of React nodes representing each step.
   */
  steps: React.ReactNode[];

  /**
   * The index of the current step.
   */
  currentStep: number;
  /**
   * The class name to apply to the container.
   */
  className?: string;
};

export const Steps = ({ steps, currentStep, className }: StepsProps) => {
  return (
    <div className={clsx(className, styles.container)}>
      {steps.map((step, index) => (
        <Fragment key={index}>
          {index !== 0 && <div className={clsx(styles.separator, index <= currentStep && styles.completed)} />}
          <div
            className={clsx(
              styles.step,
              index === currentStep && styles.active,
              index < currentStep && styles.completed,
            )}
          >
            <div className={styles.circle}>
              {index < currentStep ? <Check size={18} aria-label="completed" /> : <span>{index + 1}</span>}
            </div>
            <div>{step}</div>
          </div>
        </Fragment>
      ))}
    </div>
  );
};
